import { render, staticRenderFns } from "./form_reg_events.vue?vue&type=template&id=e6b36e8e&scoped=true&"
import script from "./form_reg_events.vue?vue&type=script&lang=js&"
export * from "./form_reg_events.vue?vue&type=script&lang=js&"
import style0 from "./form_reg_events.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./form_reg_events.vue?vue&type=style&index=1&id=e6b36e8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6b36e8e",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VForm,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/home/eu/public_ru/local/templates/international/int_site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e6b36e8e')) {
      api.createRecord('e6b36e8e', component.options)
    } else {
      api.reload('e6b36e8e', component.options)
    }
    module.hot.accept("./form_reg_events.vue?vue&type=template&id=e6b36e8e&scoped=true&", function () {
      api.rerender('e6b36e8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/main/form_reg_events.vue"
export default component.exports